import api from "../../../../app/ApiConfig";
import { Apis } from "../../../../config";
import { NotificationManager } from "react-notifications";

const getWalletCreate = async (custId) => {
  try {
    let result = await api.post(
      Apis.GetWalletCreate,
      { custId }, // send as object
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getWalletByCustomerId = async (custId) => {
  try {
    let result = await api.post(Apis.GetWalletByCustomerId, { custId });

    if (!result.data.success) {
      return null;
    }

    return result.data; // ✅ WALLET OBJECT
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getDebitWalletbyCustomer = async (data) => {
  try {
    const result = await api.post(Apis.GetDebitWallet, data); // ✅ FIX

    if (!result.data.success) {
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getAllWalletPackageList = async () => {
  try {
    let result = await api.get(Apis.GetAllWalletPackageList);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getWalletTransactionsByCustomerId = async (custId) => {
  try {
    const result = await api.post(Apis.GetWalletTransactionsByCustomerId, {
      custId,
      page: 1,
      limit: 20,
    });

    if (!result.data.success) {
      return [];
    }

    return result.data.transactions || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};


const reconcilePreWalletByCustomer = async (custId) => {
  try {
    const result = await api.post(
      Apis.ReconcilePreWalletByCustomer,
      { custId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!result.data.success) {
      console.warn("Wallet reconcile skipped:", result.data.message);
      return null;
    }

    return result.data;
  } catch (error) {
    console.error("Wallet reconcile error:", error);
    return null;
  }
};




export default {
  getWalletCreate,
  getWalletByCustomerId,
  getAllWalletPackageList,
  getDebitWalletbyCustomer,
  getWalletTransactionsByCustomerId,
  reconcilePreWalletByCustomer
};
